import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { ENVIRONMENT_INITIALIZER, EnvironmentProviders, inject, Provider } from "@angular/core";
import { AuthService } from "app/core/auth/auth.service";
import { defaultInterceptor } from "./default.interceptor";

export const provideHttpDefault = (): Array<Provider | EnvironmentProviders> => {
  return [
    provideHttpClient(withInterceptors([defaultInterceptor])),
    {
      provide: ENVIRONMENT_INITIALIZER,
      useValue: () => inject(AuthService),
      multi: true,
    },
  ];
};
